$(function() {

  $('.accordion').accordion();

});

scrollContent = function(id) {
  // Simple scroll function to scroll to an ID e.g.
  // scrollContent($(this).attr("id"));
  $('html,body').animate({
    scrollTop: $("#"+id).offset().top -10},
  'slow');
}

$.fn.accordion = function(options) { 
  var settings = $.extend({
      // These are the defaults options
      backgroundImageAnimation: false
  }, options);
  return this.each(function() {
    var $this = $(this),
        item = $this.find("article"),
        header = $this.find("h3");
    item.find(".content").hide();
    item.on('click', function(e){
      scrollContent('product-faq');
      var content = item.find(".content"),
          $target = $(e.target);
      if($target.is('h3')) {
        if(!$(this).hasClass('active')) {
          content.slideUp();
          $(this).find(".content").slideToggle('fast');
          item.removeClass("active");
          $(this).addClass("active");
        } else {
          $(this).find(".content").slideUp('fast');
          $(this).removeClass("active");
        }
      }
    });
  });
}